<template>
  <component
    :is="$route.meta.layoutComponent"
    :info="user"
    :isInfoLoading="isInfoLoading"
  >
    <slot />
  </component>
</template>
<script>
import { mapState } from "vuex";
import { createRequest } from "@/api/requestBuilder";
import requestConfigs from "@/api/requestConfigs";
import store from "@/store";

export default {
  name: "AppLayout",
  data() {
    return {
      isInfoLoading: false,
    };
  },
  watch: {
    async frontVersion(value) {
      if (!value) return;
      this.$store.commit("setServerAvatar", "");
      this.$store.commit("user/killUserFull");

      const requests = [this.getSystemInfo(), this.getProjectsInfo()];

      await this.allConfigRequests(requests, value);
    },
    $route() {
      if (this.isTelegram) {
        this.$store.commit("user/setIsTelegramInfo", true);
      }
      this.checkProfile();
    },
  },
  computed: {
    ...mapState([
      "trayItems",
      "storage",
      "frontVersion",
      "isStorageInfoLoading",
    ]),
    ...mapState("user", [
      "user",
      "isAuthenticated",
      "isTelegram",
      "setIsProfileMustEdit",
      "setIsPassportMustEdit",
    ]),
  },
  methods: {
    checkProfile() {
      if (
        this.isAuthenticated &&
        !this.isTelegram &&
        this.$route.name !== "ProfileData" &&
        this.$route.name !== "PersonalData"
      ) {
        if (this.setIsProfileMustEdit || this.setIsPassportMustEdit) {
          this.$store.commit("setCurrentPopup", {
            name: "PopupMustEdit",
            isShown: true,
          });
        }
      }
    },
    async getSystemInfo() {
      await createRequest(requestConfigs.GETSystemInfo).then((result) => {
        this.$store.commit("setStorageData", [result, "systemInfo"]);
      });
    },
    async getProjectsInfo() {
      await createRequest(requestConfigs.GETSProjectsList).then((result) => {
        this.$store.commit("setStorageData", [result.data, "projectsList"]);
      });
    },
    async getUserInfo() {
      this.isInfoLoading = true;
      await this.$store.dispatch("user/getUserInfo");
      this.isInfoLoading = false;
    },
    async allConfigRequests(requests, frontVersion) {
      this.$store.commit("setStorageInfoLoading", true);
      if (frontVersion) {
        this.$store.commit("setStorageData", [[], "projectsList"]);
        this.$store.commit("setStorageData", [{}, "systemInfo"]);
      }
      await Promise.all(requests);
      store.commit("setStorageInfoLoading", false);
    },
  },
  async beforeMount() {
    if (this.isStorageInfoLoading) return;

    const requests = [];
    if (this.isAuthenticated) {
      requests.push(this.getUserInfo());
    }

    if (
      !this.storage.systemInfo ||
      Object.keys(this.storage.systemInfo).length === 0
    ) {
      requests.push(this.getSystemInfo());
    }

    if (!this.storage.projectsList || this.storage.projectsList.length === 0) {
      requests.push(this.getProjectsInfo());
    }

    if (requests.length > 0) {
      await this.allConfigRequests(requests);
    }
    this.checkProfile();
  },
};
</script>

<style scoped lang="scss"></style>
